module.exports = __webpack_public_path__ + "static/media/0010_IMG_LES_MURS_PAPIER_BRIQUE_BLANCHE.eb1a74eb.webp";